import { FC, MouseEvent, cloneElement, useState } from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ArrowRightIcon from 'mdi-react/ArrowRightIcon';
import PencilIcon from 'mdi-react/PencilIcon';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Color } from '../Theme';

const EditButton = styled(Button)`
  align-self: center;
  box-shadow: none !important;
  border-radius: 50px !important;

  &.MuiButton-containedPrimary {
    color: ${Color.white};
  }

  .MuiCircularProgress-root {
    margin-left: 5px;
    margin-right: -5px;

    svg {
      color: ${Color.white};
    }
  }
`;

export interface CompanyEditButtonProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const CompanyEditButton: FC<CompanyEditButtonProps> = ({ onClick }) => {
  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    onClick(event);
  };

  return (
    <EditButton
      variant="contained"
      color="default"
      size="large"
      disableElevation
      onClick={handleButtonClick}
      endIcon={<PencilIcon size={18} />}
    >
      Muokkaa
    </EditButton>
  );
};
